import useSecureFetch from "./useSecureFetch";
import AppSettings from "../../AppSettings";

export default function useCheckoutInfo(customerId) {
  const url = customerId ? `${AppSettings.ApiGetCheckoutInfo(customerId)}` : null;
  const result = useSecureFetch(url, null, true, json => console.log("GetCheckoutInfo", json));

  return result;
}
